import axios from "axios";
import React from "react";
import { useGlobalStore } from "../hooks/useGlobalStore";
import { useApiRoutes } from "../hooks/useApiRoutes";
import { useSSAuth } from "../hooks/useSSAuth";
import { useTeamConfig } from "../components/TeamConfigProvider";
import { constants } from "src/shared/constants";
import { useLogout } from "../hooks/useLogout";
import { global_config } from "src/shared/global_config";

export function SessionUnauthorizedHandler(props: {
  children: React.ReactNode;
}) {
  const { TEAM_GLOBAL_SETTINGS } = useTeamConfig();
  const { apiRoutes } = useApiRoutes();
  const { persistSession } = useSSAuth();
  const { handleLogout } = useLogout();
  const { user } = useGlobalStore();

  const handleUnauthorized = async (event: any) => {
    const { err, onRefetch, onError } = event.detail;
    try {
      if (err.response?.status === 401) {
        if (TEAM_GLOBAL_SETTINGS?.LOGOUT_ON_INVALID_SESSION) {
          return await handleLogout();
        }
        const refreshRes = await axios.get(apiRoutes.refreshSession, {
          headers: {
            Authorization: err.config.headers["Authorization"],
          },
        });
        const newSession = refreshRes.data.session;
        persistSession(newSession);
        err.config.headers["Authorization"] = `Bearer ${newSession}`;
        const newRes = await axios(err.config);
        return onRefetch(newRes);
      }
    } catch (err) {
      onError(err);
    }
  };

  React.useEffect(() => {
    const { addEventListener, removeEventListener } = window;
    const { customEvents } = constants;
    addEventListener(customEvents.sessionUnauthorized, handleUnauthorized);
    return () => {
      removeEventListener(customEvents.sessionUnauthorized, handleUnauthorized);
    };
  }, []);

  React.useEffect(() => {
    // prettier-ignore
    if (user && (!user?.version || user?.version !== global_config?.logOutVersion)) {
      handleLogout();
    }
  }, [user]);

  return <>{props.children}</>;
}
